import { Link, useNavigate } from 'react-router'

import { StatusPill } from '@/components/StatusPill'
import { Button } from '@/components/ui/button'
import { TablePagination } from '@/components/ui/pagination'
import { ResponsiveTable, type ResponsiveTableColumn } from '@/components/ui/responsive-table'
import { SkeletonRows } from '@/components/ui/skeleton'
import { type OrgListItem, orgPillStatus, useOrganisations } from '@/models/user'
import { usePageParam } from './usePageParam'

const COLUMNS: ResponsiveTableColumn<OrgListItem>[] = [
  { key: 'name', header: 'Name', cellClassName: 'font-medium', hideOnCard: true, cell: (org) => org.name },
  { key: 'status', header: 'Status', cell: (org) => <StatusPill status={orgPillStatus(org)} /> },
  { key: 'users', header: 'Users', cell: (org) => org.userCount ?? 0 },
]

export function StaffCustomersTab({ staffUserId }: { staffUserId: string }) {
  const navigate = useNavigate()
  const [page, setPage] = usePageParam()
  const { organisations, count, hasNextPage, hasPreviousPage, isLoading } = useOrganisations({
    page,
    salesOwner: staffUserId,
    keepPrevious: true,
  })

  return (
    <div className="flex flex-col gap-4">
      <Button variant="link" asChild className="h-auto self-end p-0 text-sm">
        <Link to={`/insure/internal/customers?sales_owner=${staffUserId}`}>Open in Customers</Link>
      </Button>
      {isLoading ? (
        <SkeletonRows rows={5} />
      ) : (
        <ResponsiveTable
          items={organisations}
          columns={COLUMNS}
          getRowId={(org) => org.id}
          cardTitle={(org) => org.name}
          onRowClick={(org) => navigate(`/insure/internal/customers/${org.id}`)}
          empty="No customers assigned"
        />
      )}
      <TablePagination
        page={page}
        count={count}
        hasNextPage={hasNextPage}
        hasPreviousPage={hasPreviousPage}
        onPageChange={setPage}
        itemLabel="customer"
      />
    </div>
  )
}
